function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M507.681,209.011c-1.297-6.991-7.323-12.112-14.433-12.262c-7.145-0.155-13.346,4.712-14.936,11.642 c-15.26,66.498-73.643,112.941-141.978,112.941c-80.321,0-145.667-65.346-145.667-145.666 c0-68.335,46.443-126.718,112.942-141.976c6.93-1.59,11.791-7.827,11.643-14.934c-0.149-7.108-5.269-13.136-12.259-14.434 C287.545,1.454,271.735,0,256,0C187.62,0,123.333,26.629,74.98,74.981C26.629,123.333,0,187.62,0,256 s26.629,132.667,74.98,181.019C123.333,485.371,187.62,512,256,512s132.667-26.629,181.02-74.981 C485.371,388.667,512,324.38,512,256C512,240.278,510.547,224.469,507.681,209.011z M256,482C131.383,482,30,380.617,30,256 c0-118.227,91.264-215.544,207.036-225.212c-14.041,9.63-26.724,21.303-37.513,34.681 c-25.058,31.071-38.857,70.207-38.857,110.197c0,96.863,78.804,175.666,175.667,175.666c39.99,0,79.126-13.8,110.197-38.857 c13.378-10.789,25.051-23.471,34.682-37.511C471.544,390.736,374.228,482,256,482z"
})));

function SvgNight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    height: 32,
    viewBox: "0 0 512 512",
    width: 32,
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.f6dd76d6.svg";
export { ForwardRef as ReactComponent };